import React, { useEffect, useState, useContext } from 'react'
import OLOverlay from 'ol/Overlay'
import { MapContext } from './Map'

export default (props) => {

	const map = useContext(MapContext)
	const [olOverlay, setOlOverlay] = useState()
	const [offset] = useState(props.offset)
	const [position] = useState(props.position)
	const [positioning] = useState(props.positioning)
	const [overlayClassName] = useState(props.overlayClassName)

	useEffect(() => {
		setOlOverlay(new OLOverlay({
			element: document.getElementById('info_window'),
			offset: offset,
			position: position,
			positioning: positioning,
			className: overlayClassName
		}))
	}, [offset, overlayClassName, position, positioning])

	useEffect(() => {
		if (!map) return

		map.addOverlay(olOverlay)

		return (() => {
			map.removeOverlay(olOverlay)
		})
	}, [map, olOverlay])

	useEffect(() => {
		if (!olOverlay) return
		olOverlay.setPosition(props.position)

	}, [olOverlay, props.position])

	return (
		<div id='info_window' className={props.className}>
			{props.children}
		</div>
	)
}